module.exports = fox._r("images/ie.png", __webpack_public_path__ + "_/_/_/common/frame/images/ie.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/ie.png
// module id = 157
// module chunks = 2